// Backend media (/media/...) lives on the API origin (API base minus "/api").
// Absolute URLs (remote product images) pass through unchanged.
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000/api'

export function resolveMediaUrl(url) {
  if (!url) return null
  return url.startsWith('/') ? `${API_BASE_URL.replace(/\/api\/?$/, '')}${url}` : url
}
